export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/types-operations/getters.js